import { render, staticRenderFns } from "./ProductCarouselRecentlyBought.vue?vue&type=template&id=1283d20e"
import script from "./ProductCarouselRecentlyBought.vue?vue&type=script&lang=js"
export * from "./ProductCarouselRecentlyBought.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports